const i18nConfig = {
  defaultLocale: 'en',
  locales: ['en'],
};

export default i18nConfig;
